module.exports = __webpack_public_path__ + "static/img/zhuanli-5.74c7e35d.png";